<template>
    <el-dialog :before-close="noDialog" :fullscreen="dialogFullscreen" :visible.sync="dialog" title="启用提示">
        <div>确定要启用吗?</div>
        <div slot="footer">
            <el-button @click="noDialog">取 消</el-button>
            <el-button type="primary" @click="unbindGet">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import dialogMixin from "@/mixin/dialogMixin";
    import resDisposeMixin from "@/mixin/resDisposeMixin";
    import memberCarApi from "@/api/device/UserCar";
    export default {
        name: "showEnableMemberDialog",
        props: {
            deviceId: Number
        },
        mixins: [dialogMixin, resDisposeMixin],
        methods: {
            unbindGet() {
                memberCarApi.agentEnableCar(this.deviceId).then(res => {
                    this.resNoDialog({res})
                })
            },
        }
    }
</script>
